import { mapRecordFromServer, mapRecordsFromServer } from 'core/mappers';
import { partfinitiClient } from 'core/services';
import { GetManyResponse, GetOneResponse, IRequestPayload } from 'core/types';
import { getQueryStringToSnakeCase } from 'core/utils';
import { ICorporatePricingProfile, IPricingProfile } from 'pricing/types';

export const getPricingProfileAutocomplete = async (
  requestPayload?: IRequestPayload
): Promise<GetManyResponse<IPricingProfile>> => {
  const { data } = await partfinitiClient.get(
    `/corporate/pricing-profile/autocomplete?${getQueryStringToSnakeCase(requestPayload)}`
  );

  return mapRecordsFromServer<IPricingProfile>(data.pricing_profiles, data?.total_count);
};

export const getPricingProfile = async (
  requestPayload: { id: number },
  signal?: AbortSignal
): Promise<GetOneResponse<IPricingProfile>> => {
  const payload = {
    pricingProfile: {
      ...requestPayload,
    },
  };

  const { data } = await partfinitiClient.get(
    `/pricing/profile/index?${getQueryStringToSnakeCase(payload)}`,
    signal
  );

  return mapRecordFromServer<IPricingProfile>(data.pricing_profile);
};

export const getPricingProfiles = async (requestPayload?: IRequestPayload) => {
  const { data } = await partfinitiClient.get(
    `/pricing/profile-list/profiles?${getQueryStringToSnakeCase(requestPayload)}`
  );

  return mapRecordsFromServer<IPricingProfile>(data.data, data.recordsFiltered);
};

export const upsertPricingProfile = async (data) =>
  partfinitiClient.postForm('/corporate/pricing-profile/save', data, {
    includeNullValues: true,
  });

export const upsertPricingProfiles = async (data) =>
  partfinitiClient.postForm('/corporate/pricing-profile/save-bulk', data, {
    includeNullValues: true,
  });

export const removePricingProfiles = async (data: { ids: number[] }) =>
  partfinitiClient.postForm('/corporate/pricing-profile/remove', data);

export const getCorporatePricingProfiles = async <T = ICorporatePricingProfile>(
  requestPayload?: IRequestPayload,
  signal?: AbortSignal
) => {
  const { data } = await partfinitiClient.get(
    `/corporate/pricing-profile/list?${getQueryStringToSnakeCase(requestPayload)}`,
    signal
  );

  return mapRecordsFromServer<T>(data.data, data.recordsFiltered);
};
